import { useCurrentUser } from '@bonusly/who-am-i';

export const useAdminNavLink = () => {
	const user = useCurrentUser();
	const { awards_admin, finance_admin, global_admin, reports_admin, rewards_admin, tech_admin } = user;

	switch (true) {
		// NOTE: global, finance, and reports are checked first because if a user has multiple roles we want to link to the dashboard
		case global_admin:
		case finance_admin:
		case reports_admin:
			return { to: '/admin/dashboard', isRecognizeRoute: false };

		case rewards_admin:
			return { to: '/admin/rewards/catalog', isRecognizeRoute: false };

		case awards_admin:
			return { to: '/admin/awards', isRecognizeRoute: true };

		case tech_admin:
			return { to: '/company/settings/integrations', isRecognizeRoute: true };

		default:
			return { to: '/admin/dashboard', isRecognizeRoute: false };
	}
};
